// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__3EBei","tooltip":"Tooltip_tooltip__khvVR","icon":"Tooltip_icon__2q1lW"};